import apolloClient from "../apolloClient";
import gql from 'graphql-tag'

class CategoryService {
  async getDataByCollectionName(collectionName) {
    const QUERY = gql`
      query GetDataFromTable($tableName: String!) {
        getDataFromTable(tableName: $tableName)
      }
    `
    try {
      const response = await apolloClient.query({
        query: QUERY,
        variables: { tableName: collectionName },
        fetchPolicy: 'no-cache',
      })
      return response.data.getDataFromTable
    } catch (error) {
      console.error('Lỗi khi gọi getDataByCollectionName:', error)
      throw error
    }
  }

  async getDataByField(collectionName, field, value) {
    const QUERY = gql`
      query GetDataTableFromSearch(
        $tableName: String!
        $fieldSearch: String!
        $valueSearch: JSON!
      ) {
        getDataTableFromSearch(
          tableName: $tableName
          fieldSearch: $fieldSearch
          valueSearch: $valueSearch
        )
      }
    `
    try {
      const response = await apolloClient.query({
        query: QUERY,
        variables: {
          tableName: collectionName,
          fieldSearch: field,
          valueSearch: value,
        },
        fetchPolicy: 'no-cache',
      })
      return response.data.getDataTableFromSearch
    } catch (error) {
      console.error('Lỗi khi gọi getDataByField:', error)
      throw error
    }
  }

  async getCities(countryCode, useNewAddress) {
    const QUERY = gql`
      query getCities($countryCode: String, $useNewAddress: Boolean) {
        cities(country_code: $countryCode, useNewAddress: $useNewAddress) {
          id
          title
          __typename
        }
      }`
    try {
      const response = await apolloClient.query({
        query: QUERY,
        variables: { countryCode: countryCode, useNewAddress: useNewAddress },
      })
      return response.data.cities
    } catch (error) {
      console.error('Lỗi khi gọi getCities:', error)
      throw error
    }
  }

  async getDistricts(cityId) {
    const QUERY = gql`
      query Districts($cityId: Int!) {
        districts(cityId: $cityId) {
          id
          title
          wards {
            id
            city
            district
            ward
            ward_level
            __typename
          }
          __typename
        }
      }
    `
    try {
      const response = await apolloClient.query({
        query: QUERY,
        variables: { cityId: Number(cityId) },
      })
      return response.data.districts
    } catch (error) {
      console.error('Lỗi khi gọi getDistricts:', error)
      throw error
    }
  }
}

export default new CategoryService();